import React, { useState, useEffect } from 'react'
import TeamHeader from "../TeamHeader/TeamHeader";

// Icons
import { FaPlus } from "react-icons/fa6";
import { SiNotion } from "react-icons/si";

// -------- Interface --------
interface GisTool {
    tool_id: number;
    title: string;
    description: string;
    notion_link: string;
    type: string;
}

const AccessAndTools = () => {

    const [gisLinks, setGisLinks] = useState<GisTool[]>([])
    const [loadingGisLinks, setLoadingGisLinks] = useState(true);

    // Setting colors for tags
    const GIS_TYPE_COLOR: Record<string, string> = {
        Access: "green",
        Tools: "#355372",
    };

    // -------- Fetch GIS Tools --------
    const fetchGisTools = async () => {
        try {
            setLoadingGisLinks(true);

            const response = await fetch(
                "/apidet/gis_tools/",
                {
                    credentials: "same-origin",
                }
            );

            const data = await response.json();

            if (!response.ok) {
                console.error("Failed to fetch GIS tools:", data);
                return;
            }

            setGisLinks(data);

        } catch (error) {
            console.error("❌ Error fetching GIS tools:", error);
        } finally {
            setLoadingGisLinks(false);
        }
    };

    useEffect(() => {
        fetchGisTools();
    }, []);

    return (
        <div className="customer-directory-body">
            <TeamHeader title="GIS" />

            <div className="customer-title-and-expand-buttons">
                <h1 className="cutomer-title">Access & Tools</h1>

                <div className="ai-expand-buttons">
                    <a href="/admin/backenddetector/gistools/" target="_blank" rel="noreferrer">
                        <button className="general-sort-summary">
                            <FaPlus style={{ marginRight: "0.25rem", fontSize: "0.9rem" }} />
                            Entry
                        </button>
                    </a>
                </div>
            </div>

            <div className='marketing-resources-widgets'>

                {loadingGisLinks
                    ? Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="marketing-resource-widget">
                            <div>
                                <div className="marketing-skeleton marketing-skeleton-tag" />
                                <div className="marketing-skeleton marketing-skeleton-title" />
                                <div className="marketing-skeleton marketing-skeleton-text" />
                                <div className="marketing-skeleton marketing-skeleton-text short" />
                            </div>
                            <div className="marketing-skeleton marketing-skeleton-button" />
                        </div>
                    ))
                    : gisLinks.map(tool => (
                        <div key={tool.tool_id} className='marketing-resource-widget'>
                            <div>
                                <div
                                    className='marketing-resource-industry'
                                    style={{
                                        backgroundColor:
                                            GIS_TYPE_COLOR[tool.type] || "#8A94A6"
                                    }}
                                >
                                    {tool.type}
                                </div>

                                <h2>{tool.title}</h2>
                                <p>{tool.description}</p>
                            </div>

                            <div className='marketing-resource-buttons'>

                                {tool.notion_link && (
                                    <a
                                        href={tool.notion_link}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <button className='confirm-btn mailjet-confirm'>
                                            <SiNotion /> Notion Link
                                        </button>
                                    </a>
                                )}
                            </div>
                        </div>
                    ))
                }

            </div>
        </div>
    )
}

export default AccessAndTools
